'use strict';

const React = require('react');
const Relay = require('react-relay/classic');
const PropTypes = require('prop-types');
const get = require('lodash.get');

const copy = require('./DetailsFooter.json');
const {
    OPEN_DETAILS_FROM_SIDEBAR,
    OPEN_DETAILS_FROM_DESCRIPTION,
} = require('../../../constants/shippingConstants');

const styles = require('./DetailsFooter.scss');

/*
 TODO: UPDATES TO THIS COMPONENT HAS BEEN REVERTED TO LIMIT EXPOSURE OF REQUEST SHIPPING MODAL ONLY TO TRADE BUYERS
  BUT IT SHOULD BE ENABLED AGAIN SOON


 https://github.com/1stdibs/1stdibs.com/pull/11117/files?diff=split#diff-91cfb7835bc5fb20ba49a72ddc8d7f91
  */

let FooterQuoteBlurb = props => {
    const { hasUserId, quotes, isVerifiedTrade, openQuoteRequestModal, viewer } = props;
    const quoteRequestForAllIsEnabled = get(viewer, 'quoteRequestForAllIsEnabled');
    const hasQuotes = !!get(quotes, 'shipmentQuotes', []).length;
    const requestCopy = hasQuotes ? copy.preDisclaimer.canRequestQuote.copy : null;
    const showLink = hasUserId && (quoteRequestForAllIsEnabled || isVerifiedTrade);
    let preDisclaimer = copy.preDisclaimer.standard;

    if (!hasQuotes) {
        preDisclaimer = copy.preDisclaimer.none;
    } else if (isVerifiedTrade) {
        preDisclaimer = copy.preDisclaimer.trade;
    }

    return (
        <div>
            <div className={hasQuotes ? styles.quoteWrapper : styles.quoteWrapperNoQuotes}>
                <span className={styles.somewhereElse}>
                    {showLink && (
                        <div>
                            {requestCopy}
                            <span
                                data-tn="shipping-request-open-quote-modal"
                                className={styles.link}
                                onClick={openQuoteRequestModal}
                            >
                                {copy.preDisclaimer.canRequestQuote.linkCTA}
                            </span>
                        </div>
                    )}
                    {!showLink && preDisclaimer}
                </span>
                <span>{!showLink && copy.disclaimer}</span>
            </div>
            {hasQuotes ? null : <div className={styles.noQuotes} />}
        </div>
    );
};

FooterQuoteBlurb.propTypes = {
    viewer: PropTypes.object,
    hasUserId: PropTypes.bool,
    isVerifiedTrade: PropTypes.bool,
    quotes: PropTypes.shape({
        shipmentQuotes: PropTypes.array.isRequired,
    }).isRequired,
    source: PropTypes.oneOf([OPEN_DETAILS_FROM_SIDEBAR, OPEN_DETAILS_FROM_DESCRIPTION]).isRequired,
    openQuoteRequestModal: PropTypes.func,
};

FooterQuoteBlurb = Relay.createContainer(FooterQuoteBlurb, {
    fragments: {
        viewer: () => Relay.QL`
            fragment on Viewer {
                quoteRequestForAllIsEnabled: isEnabled(key: "enableRequestQuoteForAllLoggedIn")
            }
        `,
    },
});
function FooterLegalBlurb() {
    return (
        <div>
            <div className={styles.customsWrapper}>
                {copy.legal}
                <a href={copy.link}>{copy.linkCTA}</a>
            </div>
        </div>
    );
}

module.exports = { FooterLegalBlurb, FooterQuoteBlurb };



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsFooter.jsx